export function copyText(value) {
  return new Promise(resolve => {
    let transfer = document.createElement('input')
    document.body.appendChild(transfer)
    transfer.focus()
    transfer.value = value
    transfer.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
    }
    transfer.blur()
    document.body.removeChild(transfer)
    resolve(true)
  })
}
